import { createAsyncThunk } from "@reduxjs/toolkit";
import { IAnalyticsEarningGraph, IAnalyticsState } from "./analytics.types";
import { axios_api } from "../../api";
import { IOrder } from "../orders";

export const fetchEarningBoardAsync = createAsyncThunk<
  { recordCount: number; data: IAnalyticsEarningGraph },
  { duration_type: string; duration: string, outlet: string }
>("analytics/fetchSingleAirlineMenuListAsync", async ({ duration_type, duration, outlet }) => {
  const finalUrl = `/analytics/get-analytics-dashboard-earnings?outlet_uuid=${outlet}&duration_type=${duration_type}&duration=${duration}`;
  const response = await axios_api.get(finalUrl);
  const data = response.data.data;
  const count = response.data.totalRecords;
  return { recordCount: count, data: data };
});


export const fetchDashboardTakeAwayOrdersAsync = createAsyncThunk<{ totalRecords: number; data: IOrder[] }, string>(
  "analytics/fetchDashboardTakeAwayOrdersAsync", async (outlet) => {
    const response = await axios_api.get(`/analytics/get-analytics-dashboard-take-away-orders?outlet_uuid=${outlet}&pageNo=${1}&itemPerPage=${5}`);
    const data = response.data.data;
    const count = response.data.totalRecords;
    return { totalRecords: count, data: data };
  });



export const fetchDashboardExpenseCatgoriesAsync = createAsyncThunk<{
  totalRecords: number;
  data: IAnalyticsState["expense_categories_list"]["data"]
  overview: IAnalyticsState["expense_categories_list"]["overview"]
}, string>(
  "analytics/fetchDashboardExpenseCatgoriesAsync", async (outlet) => {
    const response = await axios_api.get(`/analytics/get-analytics-dashboard-expenses-categories?outlet_uuid=${outlet}`);
    const data = response.data.data;
    const count = response.data.totalRecords;
    return { totalRecords: count, data: data[0], overview: data[1] };
  });

export const fetchDashboardShiftsAsync = createAsyncThunk<{
  totalRecords: number;
  data: IAnalyticsState["active_shifts_list"]["data"]
}, string>(
  "analytics/fetchDashboardShiftsAsync", async (outlet) => {
    const response = await axios_api.get(`/analytics/get-analytics-dashboard-shift-details?outlet_uuid=${outlet}`);
    const data = response.data.data;
    const count = response.data.totalRecords;
    return { totalRecords: count, data };
  });